import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LoadingIndicator } from '@asset-metrix/portal-ui';
import { useQuery } from '@tanstack/react-query';

import {
  fetchLegacyUrlMapping,
  FetchLegacyUrlMappingQueryKey,
} from '../../api/portalGateway/legacyUrlMapping';
import { prependRoleId } from '../../utils/prependRoleId';

export function LegacyUrlHandler() {
  const { pathname, search } = useLocation();

  const isLegacyUrl =
    /^(\/[\da-f]{8}(?:\b-[\da-f]{4}){3}\b-[\da-f]{12})+$/.test(pathname);

  const { data, isLoading } = useQuery({
    queryKey: prependRoleId<FetchLegacyUrlMappingQueryKey>([
      'legacyUrlMapping',
      { legacyUrlPath: pathname },
    ]),
    queryFn: fetchLegacyUrlMapping,
    enabled: isLegacyUrl,
  });

  if (isLoading) {
    return (
      <LoadingIndicator
        data-testid="legacy-url-handler__loading-indicator"
        style={{
          position: 'absolute',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          left: '50%',
          fontSize: '2.5em',
        }}
      />
    );
  }

  if (data != null) {
    return <Navigate to={`/p${data.data.portalNextUrlPath}${search}`} />;
  }

  return <Outlet />;
}
